import * as Immutable from "immutable";
import React, { useMemo } from "react";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
export const SingleMessageFieldTypesProvider = ({ streams, timestamp, children }) => {
  const { data: fieldTypes } = useFieldTypes(streams, { type: "absolute", from: timestamp, to: timestamp });
  const types = useMemo(() => {
    const fieldTypesList = Immutable.List(fieldTypes);
    return { all: fieldTypesList, currentQuery: fieldTypesList };
  }, [fieldTypes]);
  return /* @__PURE__ */ React.createElement(FieldTypesContext.Provider, { value: types }, children);
};
export default SingleMessageFieldTypesProvider;
